













































































import { Component, Mixins, Watch, Ref } from "vue-property-decorator";
import { Choice, VForm } from "@/types";
import AxiosMixin from "@/mixins/axiosMixin";
import EditMixin from "@/mixins/editMixin";
import RulesMixin from "#/mixins/rulesMixin";
import PatientMixin from "@/mixins/patientMixin";
import PatientHeader from "@/components/patient/PatientHeader.vue";
import DateInput from "#/components/DateInput.vue";
import {
  MedicalInsuranceHighExpense,
  MedicalInsuranceTokuteiDisease,
  DefaultMedicalInsuranceTokuteiDisease,
  TokuteiDiseaseDiv,
  MedicalInsuranceOldAge,
  MedicalInsuranceLimitCert
} from "#/model/patient";
import * as appDate from "#/utility/appDate";
import { PATIENT } from "#/const";

@Component({
  components: {
    PatientHeader,
    DateInput
  }
})
export default class InsuranceInfoTokuteiDisease extends Mixins(
  AxiosMixin,
  EditMixin,
  RulesMixin,
  PatientMixin
) {
  @Ref("patient-header") private readonly patientHeader!: VForm;

  private insTokuteiDiseaseId = 0;
  private patientId = 0;
  private mode = "";
  private isInit = false;

  /** 特定疾病療養受療証 */
  private tokuteiDisease: MedicalInsuranceTokuteiDisease = DefaultMedicalInsuranceTokuteiDisease();

  /** 限度額認定証 */
  private limitCerts: MedicalInsuranceLimitCert[] = [];

  /** 認定証の種類 */
  private divs: Choice[] = [];

  /** 自己負担限度額額の種類 */
  private selfBearLimitAmountDiv: Choice[] = [];

  /** 医療保険(開始日の遅い順) */
  private highExpenses = false;

  /** 限度額認定証区分 */
  private limitCertDivAI = [11, 12];
  private limitCertDivUEO = [13, 14, 15];

  /** 疾病区分の選択チェック */
  private checkTokuteiDiv() {
    const isSelectingTokuteiDiv = this.divs.some(tokuteiDiv => {
      return tokuteiDiv.value === this.tokuteiDisease.tokutei_disease_div_id;
    });
    return isSelectingTokuteiDiv || "必須です";
  }

  // 特定疾病療養受療証の特定疾病区分
  private TOKUTEI_DISEASE_DIV_RENAL_FAILURE = 1; // 1:人工透析が必要な慢性腎不全
  private TOKUTEI_DISEASE_DIV_HEMOPHILIA = 2; // 2:先天性血液凝固因子障害の一部（血友病）
  private TOKUTEI_DISEASE_DIV_HIV = 3; // 3:血液凝固因子製剤の投与に起因する（血液製剤による）HIV感染症

  created() {
    this.insTokuteiDiseaseId = Number(this.$route.params.instokuteidiseaseid);
    this.patientId = Number(this.$route.params.id);
    this.mode = this.$route.query.mode as string;
    this.fetchTokuteiDisease();
  }

  mounted() {
    this.setBreadItems([
      {
        text: "利用者",
        disabled: false,
        to: "/patient/list"
      },
      {
        text: this.patientInfo.name,
        disabled: false,
        to: `/patient/${this.patientId}/insurance?key=TokuteiDisease`
      },
      {
        text: "特定疾病療養受療証",
        disabled: true,
        to: ""
      }
    ]);
  }

  get IsReceipt() {
    return this.tokuteiDisease.is_receipt ? 0 : 1;
  }

  set IsReceipt(value) {
    this.tokuteiDisease.is_receipt = value == 0 ? 1 : 0;
  }

  /** キャンセル */
  private cancel() {
    this.$router.go(-1);
  }

  /** 登録 */
  private async save() {
    if (!this.patientHeader.validate()) {
      await this.$openAlert("入力内容に不備があります。");
      return;
    }

    // 疾病名、年齢、限度額でおかしい組み合わせを弾く
    const errMsg = this.checkValidTokuteiDisease(this.tokuteiDisease);
    if (errMsg) {
      await this.$openAlert(errMsg);
      return;
    }

    const isOver70 = this.isTokuteiDiseaseOverAge(
      this.tokuteiDisease.start_date,
      70
    );

    // 70歳未満で限度額認定証の登録がなく、自己負担額の選択がされていないときは弾く
    if (
      this.tokuteiDisease.tokutei_disease_div_id ==
        this.TOKUTEI_DISEASE_DIV_RENAL_FAILURE &&
      !isOver70 &&
      !this.limitCerts &&
      !this.tokuteiDisease.self_bear_limit_amount
    ) {
      await this.$openAlert("自己負担限度額を選択してください");
      return;
    }

    // 未選択は限度額を自動選択する
    if (this.tokuteiDisease.self_bear_limit_amount == 0) {
      if (
        this.tokuteiDisease.tokutei_disease_div_id ==
        this.TOKUTEI_DISEASE_DIV_RENAL_FAILURE
      ) {
        // 慢性腎不全
        if (isOver70) {
          this.tokuteiDisease.self_bear_limit_amount = 10000;
        } else {
          // 70歳未満
          // 区分がアイの限度額認定証の登録がある場合は限度額20000円
          if (
            this.isLimitCertDiv(
              this.tokuteiDisease.start_date,
              this.limitCertDivAI
            )
          ) {
            this.tokuteiDisease.self_bear_limit_amount = 20000;
          } else {
            // 区分がアイ以外の登録、もしくは限度額認定証の登録がない場合は限度額10000円
            this.tokuteiDisease.self_bear_limit_amount = 10000;
          }
        }
      } else {
        this.tokuteiDisease.self_bear_limit_amount = 10000;
      }
    }

    if (this.mode) {
      this.tokuteiDisease.id = 0;
    }
    this.tokuteiDisease.patient_id = this.patientId;
    this.postJsonCheck(
      window.base_url + "/api/patient/insurance/tokuteidisease/save",
      {
        tokutei_disease: this.tokuteiDisease
      },
      async res => {
        if (res.data.code > 0) {
          await this.$openAlert(res.data.message);
          return;
        }

        this.setNoEditMode();
        this.cancel();
      }
    );
  }

  /** 変更 */
  private update() {
    this.tokuteiDisease.id = this.insTokuteiDiseaseId;
    this.save();
  }

  /** 削除 */
  private async clickDelete() {
    if (await this.$openConfirm("削除します。よろしいですか？")) {
      this.tokuteiDisease.id = this.insTokuteiDiseaseId;
      this.postJsonCheck(
        window.base_url + "/api/patient/insurance/tokuteidisease/delete",
        { tokutei_disease: this.tokuteiDisease },
        () => {
          this.setNoEditMode();
          this.cancel();
        }
      );
    }
  }

  /** 特定疾病療養受療証を取得 */
  private fetchTokuteiDisease() {
    this.postJsonCheck(
      window.base_url + "/api/patient/insurance/tokuteidisease/get",
      {
        patient_id: this.patientId,
        ins_tokutei_disease_id: this.insTokuteiDiseaseId
      },
      res => {
        this.divs = res.data.divs;
        this.selfBearLimitAmountDiv = res.data.self_bear_limit_amount_divs;
        this.highExpenses = res.data.is_high_exp_exsist;
        /** 編集する特定疾病療養受療証 */
        const tokuteiDisease: MedicalInsuranceTokuteiDisease =
          res.data.tokutei_disease;
        if (tokuteiDisease) {
          if (this.mode) {
            // コピー作成時、期間は空にする
            tokuteiDisease.start_date = "";
            tokuteiDisease.end_date = "";
          }
          this.tokuteiDisease = tokuteiDisease;
        } else {
          this.tokuteiDisease = DefaultMedicalInsuranceTokuteiDisease();
        }
        this.limitCerts = res.data.limit_certs;

        this.setLoaded();
      }
    );
  }

  /** 検索条件バリデーション：期間の開始日 */
  private checkStartDate(): boolean | string {
    const startDate = this.newDate(this.tokuteiDisease.start_date);
    const endDate = this.newDate(this.tokuteiDisease.end_date);
    //高額療養費を作成する場合
    if (this.tokuteiDisease.is_make_high_expense) {
      const target = this.newDate("2018-08-01");
      if (target > startDate) {
        return "高額療養費への登録は有効期限（開始日）が平成30年8月1日(2018年8月1日)以降の場合に可能です";
      }
    }
    //開始日が終了日よりも後である場合
    if (startDate > endDate) {
      return "開始日は終了日よりも前に設定してください";
    }
    return true;
  }

  /** 検索条件バリデーション：期間の終了日 */
  private checkEndDate(): boolean | string {
    const startDate = this.newDate(this.tokuteiDisease.start_date);
    const endDate = this.newDate(this.tokuteiDisease.end_date);
    //終了日が開始日よりも前である場合
    if (startDate > endDate) {
      return "終了日は開始日よりも後に設定してください";
    }
    return true;
  }

  /** 登録時バリデーション */
  private checkValidTokuteiDisease(
    tokutei: MedicalInsuranceTokuteiDisease
  ): string {
    // 限度額未選択の場合
    if (tokutei.self_bear_limit_amount == 0) {
      return "自己負担限度額を登録してください。";
    }

    const isOver70 = this.isTokuteiDiseaseOverAge(tokutei.start_date, 70);

    // 慢性腎不全で70歳未満
    if (
      tokutei.tokutei_disease_div_id ==
        this.TOKUTEI_DISEASE_DIV_RENAL_FAILURE &&
      !isOver70
    ) {
      // 限度額認定証の登録がある場合
      if (this.limitCerts) {
        const isLimitCertDivAI = this.isLimitCertDiv(
          tokutei.start_date,
          this.limitCertDivAI
        );
        const isLimitCertDivUEO = this.isLimitCertDiv(
          tokutei.start_date,
          this.limitCertDivUEO
        );

        // 区分がアイの限度額認定証の登録がある場合は限度額20000円
        if (isLimitCertDivAI && tokutei.self_bear_limit_amount == 10000) {
          return "自己負担限度額は20000円です。";
        } else if (
          isLimitCertDivUEO &&
          tokutei.self_bear_limit_amount == 20000
        ) {
          // 区分がアイ以外の登録、もしくは限度額認定証の登録がない場合は限度額10000円
          return "自己負担限度額は10000円です。";
        }
      } else {
        // 限度額認定証の登録がない場合はどちらでも可
        return "";
      }
    }

    // 70歳以上、もしくは慢性腎不全以外で限度額2万円はない
    if (
      (isOver70 ||
        tokutei.tokutei_disease_div_id !=
          this.TOKUTEI_DISEASE_DIV_RENAL_FAILURE) &&
      tokutei.self_bear_limit_amount == 20000
    ) {
      return "自己負担限度額は10000円です。";
    }

    return "";
  }

  private requiredInsurerNo(insurer_no: string): boolean | string {
    return this.required(insurer_no, "必須です");
  }

  // 特定疾病の70歳判定のロジック
  protected isTokuteiDiseaseOverAge(targetDate: string, minAge: number) {
    if (targetDate === "") {
      targetDate = this.dateToStr(new Date(), "yyyy-MM-dd");
    }
    const rawBirthday = this.strToDate(this.patientInfo.bday);
    // 誕生日が1日以外の場合は翌月1日と考える
    const birthday = this.addMonthAndSetToFirst(rawBirthday);
    const bMonth = birthday.getMonth();
    const patientMinAgeDay = birthday;
    patientMinAgeDay.setFullYear(patientMinAgeDay.getFullYear() + minAge);
    // 閏年の2月29日から、minAge年後の3月1日になってしまった場合、みなし誕生日の2月28日に補正する
    if (patientMinAgeDay.getMonth() !== bMonth) {
      patientMinAgeDay.setDate(0);
    }
    return targetDate >= this.dateToStr(patientMinAgeDay, "yyyy-MM-dd");
  }

  /** 指定した日付が1日以外の場合 翌月1日に変換 */
  protected addMonthAndSetToFirst(birthday: Date): Date {
    const newDate = new Date(birthday);
    // 1日以外の場合は翌月1日に設定
    if (newDate.getDate() !== 1) {
      newDate.setMonth(newDate.getMonth() + 1);
      newDate.setDate(1);
    }
    return newDate;
  }

  protected isLimitCertDiv(targetDate: string, targetDivs: number[]) {
    // 限度額認定証がない
    if (
      this.limitCerts === undefined ||
      this.limitCerts === null ||
      this.limitCerts.length == 0
    ) {
      return false;
    }

    const date = this.strToDate(targetDate);

    // 特定疾病の開始期限で有効、かつ区分アイの登録がある限度額認定証を取得
    const effectiveLimitCerts = this.limitCerts.filter(
      (cert: MedicalInsuranceLimitCert) => {
        const limitStart = this.strToDate(cert.start_date);
        const limitEnd = cert.end_date
          ? this.strToDate(cert.end_date)
          : this.strToDate(cert.end_date);
        const limitDiv = cert.limit_div;

        return (
          (!targetDate || (limitStart <= date && date <= limitEnd)) &&
          limitDiv.high_expense_term_id == 3 &&
          targetDivs.includes(limitDiv.high_expense_div_id)
        );
      }
    );

    // 区分がアイの限度額認定証が存在するか
    return 0 < effectiveLimitCerts.length;
  }

  //-----------------------------------------------------
  // Watch表示切り替え
  //-----------------------------------------------------
  //編集モード設定
  @Watch("tokuteiDisease", { deep: true })
  private watchData() {
    if (this.IsLoaded) {
      this.setEditMode();
    }
  }

  // @watch:開始日変更
  @Watch("tokuteiDisease.start_date")
  private async watchStartDate(newValue: string, oldValue: string) {
    // 登録済みデータでAPI呼び出し完了後に最初に呼び出された際は以降の処理はスキップ
    if (this.tokuteiDisease.id && !this.isInit) {
      this.isInit = true;
      return;
    }

    if (this.tokuteiDisease.tokutei_disease_div_id == 0) {
      return;
    }

    // 開始日が設定されている場合のみ限度額を自動選択
    if (newValue && newValue !== "") {
      const isOver70 = this.isTokuteiDiseaseOverAge(
        this.tokuteiDisease.start_date,
        70
      );
      if (isOver70) {
        // 70歳以上はどの病名でも10000円
        this.tokuteiDisease.self_bear_limit_amount = 10000;
      } else {
        // 70歳未満
        if (
          this.tokuteiDisease.tokutei_disease_div_id ==
          this.TOKUTEI_DISEASE_DIV_RENAL_FAILURE
        ) {
          // 慢性腎不全
          const isLimitCertDivAI = this.isLimitCertDiv(
            this.tokuteiDisease.start_date,
            this.limitCertDivAI
          );
          const isLimitCertDivUEO = this.isLimitCertDiv(
            this.tokuteiDisease.start_date,
            this.limitCertDivUEO
          );
          if (this.limitCerts) {
            if (isLimitCertDivAI) {
              // 区分アイの限度額認定証があるときは20000円を設定
              this.tokuteiDisease.self_bear_limit_amount = 20000;
            } else if (isLimitCertDivUEO) {
              // 区分ウエオの限度額認定証がある場合は10000円
              this.tokuteiDisease.self_bear_limit_amount = 10000;
            } else {
              // 区分がアイウエオ以外の限度額認定証の登録がある場合は未選択
              this.tokuteiDisease.self_bear_limit_amount = 0;
            }
          } else {
            // 限度額認定証の登録がない場合は未選択
            this.tokuteiDisease.self_bear_limit_amount = 0;
          }
        } else {
          // 慢性腎不全以外
          this.tokuteiDisease.self_bear_limit_amount = 10000;
        }
      }
    } else {
      // 開始日が未設定の場合は限度額を未選択にする
      this.tokuteiDisease.self_bear_limit_amount = 0;
    }
  }
}
